class StickyHeader {
  constructor() {
    this.stickyHeaderWrap = document.getElementById('StickyHeaderWrap');
  }

  updateHeight() {
    const stickyHeaderInner = this.stickyHeaderWrap.querySelector('.site-header');

    if (!this.stickyHeaderWrap) {
      return;
    }

    const height = stickyHeaderInner.offsetHeight;
    this.stickyHeaderWrap.style.height = `${height}px`;
  }

  init() {
    if (!this.stickyHeaderWrap) return;

    window.addEventListener('scroll', () => this.updateHeight());
    this.updateHeight();
  }
}

class PopupHandler {
  constructor() {
    this.html = document.documentElement;
    this.popup = document.querySelector('.site-header__search-container');
    this.searchClose = document.querySelector('#SearchClose');
  }

  closePopupOnClickOutside(event) {
    if (
      this.html.classList.contains('js-drawer-open--search') &&
      this.popup &&
      this.searchClose &&
      !this.popup.contains(event.target)
    ) {
      this.searchClose.click();
    }
  }

  init() {
    document.addEventListener('click', (event) =>
      this.closePopupOnClickOutside(event)
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const stickyHeader = new StickyHeader();
  stickyHeader.init();

  const popupHandler = new PopupHandler();
  popupHandler.init();
});
